import { UserContextRole, UserRole } from '../../enums';
import { IAbilityComplexSubject } from '../abilities.types';

export interface IAbilityTimeSpent {
    userId: string;
}

export enum TimeSpentSubject {
    SPECIFIC_USER = 'SPECIFIC_USER',
}

export interface ITimeSpentCalculatedSubject extends IAbilityComplexSubject {
    relationRole: Array<UserRole | UserContextRole>;
    subSubject: Array<TimeSpentSubject>;
}
